import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { ApolloError } from '@apollo/client';
import {
  useCodeConfirmationMutation,
  useResendCodeConfirmationMutation,
  UserStatusTypes,
  useUserInfoByTokenLazyQuery,
  type User,
} from '@common/Providers/GraphqlProvider/generated';
import VerificationCode from '@common/VerificationCode';
import { t } from '@lingui/macro';
import { ROUTES_CLIENT, TOKEN_ADMIN } from '@utils/constants';
import useUserStore from '@utils/store/store';
import { useLoginConfirm } from '@views/Admin/public/Login/Form';
import Cookies from 'js-cookie';

type Props = { children: React.ReactElement };

const getTokenFromCookies = (path: string) => {
  if (path.startsWith('/admin')) {
    return Cookies.get(TOKEN_ADMIN);
  }
  return Cookies.get('token');
};

const UserProvider = ({ children }: Props) => {
  const { logInConfirmClient } = useLoginConfirm();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState<string>();
  const { route, replace, reload } = useRouter();
  const [userInfoBtyToken] = useUserInfoByTokenLazyQuery();
  const [codeConfirmation] = useCodeConfirmationMutation();
  const { save, user, saveDependencyId } = useUserStore();
  const [showModal, setShowModal] = useState(user?.status === UserStatusTypes.Inactive);
  const [resendCode] = useResendCodeConfirmationMutation({
    variables: {
      resendCodeConfirmationInput: {
        email: user?.email || '',
      },
    },
  });

  useEffect(() => {
    setShowError('');
  }, [code]);

  useEffect(() => {
    if (user) {
      setShowModal(user?.status === UserStatusTypes.Inactive);
    }
  }, [user]);

  useEffect(() => {
    (async () => {
      // const token = Cookies.get('token');
      const token = getTokenFromCookies(window.location.pathname);

      if (token) {
        const response = await userInfoBtyToken({ variables: { validateTokenInput: { token } } });
        save({ user: response?.data?.validateUserToken });
        // if  localStorage.getItem('dependencyId') ||
        // saveDependencyId(localStorage.getItem('dependencyId') || undefined);
        saveDependencyId(Cookies.get('dependencyId') || undefined);
      }
    })();
  }, [route]);

  const onVerificationCode = async () => {
    try {
      setLoading(true);
      const response = await codeConfirmation({
        variables: { createInput: { code, email: user?.email || '' } },
      });
      await replace(ROUTES_CLIENT.DASHBOARD);

      setLoading(false);
      await logInConfirmClient(
        true,
        Cookies.get('token') || '',
        response.data?.codeConfirmation as User,
        false
      );
    } catch (error: any) {
      if (error instanceof ApolloError) {
        setLoading(false);
        const { graphQLErrors, networkError } = error;
        if (graphQLErrors?.length) {
          setShowError(error.graphQLErrors[0].message);
          return;
        }

        if (networkError) {
          setShowError(
            'Error de conexión, vuelva a intentarlo'
          );
        }
      }
    }
  };

  return (
    <>
      {/* <VerificationCode
        resendCode={resendCode}
        show={showModal}
        email={user?.email}
        handler={() => {}}
        submit={onVerificationCode}
        // onCancel={reload}
        onCancel={() => setShowModal(false)}
        code={code}
        setCode={setCode}
        loading={loading}
        error={showError}
      />  */}
      {children}
    </>
  );
};

export default UserProvider;
